import log from 'salvo-lite/log'

import SideMenu from './header/SideMenu'
import StickyHeader from './header/StickyHeader'

class siteHeader {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._sideMenu = new SideMenu(theme, elem)
        this._stickyHeader = new StickyHeader(theme, elem)
        this._searchForm = this._elem.querySelector('[data-header-search]')
        this._searchFormButton = this._searchForm.querySelector('[data-search-button]')
        log.debug('SiteHeader', 'Constructed', this)
    }

    onInit () {
        log.debug('SiteHeader', 'Initiating')
        this._sideMenu.onInit()
        this._stickyHeader.onInit()
        this.sideMenu(this._sideMenu._sideMenu)
        this.stickHeader(this._elem)
        this.searchForm()
        log.debug('SiteHeader', 'Initiated')
    }

    searchForm () {
        if (!this._searchFormButton) return

        document.addEventListener('click', (e) => {
            if (e.target !== this._searchForm && e.target.parentNode && e.target.parentNode !== this._searchForm) {
                this._searchForm.classList.remove('open')
            }
        })
        this._searchFormButton.addEventListener('click', (e) => {
            let form = this._searchForm
            let input = this._searchFormButton.previousElementSibling

            if (input.value.length > 0) {
                return false
            } else {
                e.preventDefault()
            }

            form.classList.toggle('open')

            if (form.classList.contains('open')) {
                this._searchFormButton.setAttribute('type', 'submit')

                setTimeout(() => {
                    input.focus()
                }, 350)
            } else {
                this._searchFormButton.setAttribute('type', 'button')
            }
        })
    }

    sideMenu (elem) {
        log.debug('SideMenu', 'Side Menu', this)
        let elemBody = document.body
        elem.addEventListener('side-menu-toggled', e => {
            log.debug('Side Menu', 'Side Menu Toggle Occurred', e)
            if (e.open) {
                elemBody.classList.add('overlay')
                elemBody.overlayStatus = e.open
                return false
            }
            elemBody.classList.remove('overlay')
            elemBody.overlayStatus = e.open
        })
    }

    stickHeader (elem) {
        log.debug('SiteHeader', 'Stick Header', this)
        let mainContent = document.querySelector('#MainContent')
        elem.addEventListener('sticky-header', e => {
            if (e.hit) {
                elem.classList.add('stickied')
                mainContent.classList.add('header-stickied')
                return false
            }
            elem.classList.remove('stickied')
            mainContent.classList.remove('header-stickied')
        })
    }
}

export default siteHeader



// WEBPACK FOOTER //
// ./src/scripts/components/SiteHeader.js